var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"back-button",on:{"click":function($event){$event.preventDefault();return _vm.goBack()}}},[_vm._v(" "+_vm._s(_vm.$t("general.back"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }